import { Box, Paper, Tooltip, Typography } from '@mui/material';


export interface HelpTooltipProps {
    children: any;
    title: string | undefined;
    body: string | undefined;
}

const HelpTooltip = (props: HelpTooltipProps): JSX.Element => {

    return (
        <Tooltip
            data-testid="tooltip"
            arrow
            sx={{
                '& .MuiTooltip-tooltip': {
                    backgroundColor:'black',
                    color:'white',
                    border:'none'
                },
                '& .MuiTooltip-arrow': {
                    backgroundColor: 'yelow',
                    border:'none'
                }
            }}
            title={
                <Box sx={{
                    border: '2px solid #000000',
                    borderRadius: 1,
                    overflow: 'hidden',
                    display: 'inline-block',
                }}>
                <Paper sx={{
                    p: 2,
                    elevation:'24',
                    overflowY: 'auto',
                    maxWidth: '100%',
                    maxHeight: '200px'
                    }} >
                    <Typography variant="body1"><b>{props.title}</b></Typography>
                    <hr/>
                    <Typography variant="body2">{
                    props.body?.split('<>').map( part => (
                        <>{part}<br/></>
                    ))
                    }</Typography>
                </Paper></Box>
            }
            placement="top"
            PopperProps={{
                modifiers: [
                {
                    name: 'offset',
                    options: {
                    offset: [0, 10],
                    },
                },
                ],
            }}
            componentsProps={{
                tooltip: {
                sx: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    padding: 0,
                    maxWidth: 'none',
                },
                },
            }}>{props.children}</Tooltip>
    );
};

export default HelpTooltip;